import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-json-viewer',
    template: `
        <span class="text-right">
            <p-button pTooltip="View Json"
                      icon="pi pi-info-circle"
                      [styleClass]="styleClass"
                      (onClick)="showDialog = true"
            >
            </p-button>
        </span>
        <p-dialog [(visible)]="showDialog"
                  [style]="{width: '50vw'}"
                  maximizable="true"
                  resizable="true"
                  dismissableMask="true"
        >
            <ng-container *ngIf="model && showDialog">
                <ngx-json-viewer [json]="model" [depth]="4"></ngx-json-viewer>
            </ng-container>
        </p-dialog>
    `,
    styles: []
})
export class JsonViewerComponent {
    @Input() model: any;
    @Input() styleClass = 'p-button-text';

    showDialog = false;
}

